import { createSelector } from 'reselect';

import { RootState } from 'types/store';
import { iUiStore } from 'types/ui';

const selectUi = (state: RootState) => state.ui;

const selectIsOpenSidebar = createSelector(selectUi, (ui: iUiStore) => ui.isOpenSidebar);
const selectIsConnectionLost = createSelector(selectUi, (ui: iUiStore) => ui.isConnectionLost);

export { selectIsConnectionLost, selectIsOpenSidebar };
